const ALNUM = /[A-Za-z0-9]/;
const DIGIT = /\d/;

export const CNPJ_MASK = [
  ALNUM, ALNUM, '.',
  ALNUM, ALNUM, ALNUM, '.',
  ALNUM, ALNUM, ALNUM, '/',
  ALNUM, ALNUM, ALNUM, ALNUM, '-',
  DIGIT, DIGIT,
];

export const uppercaseCnpjPipe = (conformedValue) => {
  if (typeof conformedValue !== 'string') {
    return conformedValue;
  }
  return conformedValue.toUpperCase();
};

export const sanitizeCnpj = (value) => {
  if (value === undefined || value === null) {
    return '';
  }
  return String(value).toUpperCase().replace(/[^A-Z0-9]/g, '');
};

export const normalizeCnpj = (value) => {
  if (value === undefined) {
    return undefined;
  }
  return sanitizeCnpj(value);
};

export const sanitizeDocumento = (value) => {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return '';
  }
  return String(value).toUpperCase().replace(/[^A-Z0-9]/g, '');
};

const checkDigit = (base) => {
  let weight = 2;
  let sum = 0;

  for (let i = base.length - 1; i >= 0; i -= 1) {
    sum += (base.charCodeAt(i) - 48) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }

  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
};

export const isCnpjShape = (value) => {
  const cleaned = sanitizeCnpj(value);
  return /^[A-Z0-9]{12}\d{2}$/.test(cleaned);
};

export const isCpfShape = (value) => {
  const cleaned = sanitizeDocumento(value) || '';
  return /^\d{11}$/.test(cleaned);
};

export const validateCnpj = (value) => {
  const cleaned = sanitizeCnpj(value);

  if (!isCnpjShape(cleaned)) {
    return false;
  }

  if (/^(\d)\1{13}$/.test(cleaned)) {
    return false;
  }

  const base = cleaned.slice(0, 12);
  const expected = `${checkDigit(base)}${checkDigit(base + checkDigit(base))}`;
  return cleaned.slice(-2) === expected;
};

export const formatCnpj = (value) => {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  const cleaned = sanitizeCnpj(value);
  if (cleaned.length !== 14) {
    return String(value);
  }

  return cleaned.replace(
    /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
    '$1.$2.$3/$4-$5'
  );
};

/** redux-form `format`: store sem máscara → exibição `XX.XXX.XXX/XXXX-XX`. */
export const formatCnpjField = (value) => {
  if (value === undefined || value === null || value === '') {
    return '';
  }
  return formatCnpj(value) || String(value);
};
